module.exports = __webpack_public_path__ + "static/sqlserver-289519b77d6551c72c5d610c5116d4ff.svg";